export function makeWordId(word: string, wordIndex: number) {
  return `${word}-${wordIndex}`;
}
